import { MODAL_EXPIRY } from '../../utils/general/general';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './WarningModal.scss';

type WarningModalProps = {
  setShowModal: (v: boolean) => void;
  handleTimeout: () => void;
  warningTimer: number;
};

const WarningModal = ({ setShowModal, handleTimeout, warningTimer }: WarningModalProps) => {
  return (
    <div className="warning-modal">
      <div className="content">
        <Text type="header">Do you want to continue?</Text>
        <Text type="body">Session will end in {String(MODAL_EXPIRY + warningTimer)} seconds</Text>
        <div className="button-group">
          <Button
            buttonStyleType="primary"
            label="Yes"
            handleClick={() => setShowModal(false)}
            customStyling={{ flex: 1 }}
          />
          <Button
            buttonStyleType="primary"
            label="No"
            handleClick={handleTimeout}
            customStyling={{ flex: 1 }}
          />
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
